import { createAsyncActionTypes, createAction, LocalizedPropertyObject } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createScopedEntitiesReducer, createScopedBaseEntitySelectors } from './utils';

export const NAME = 'productCategories';

export const PRODUCT_CATEGORIES_FETCH = prefix('PRODUCT_CATEGORIES_FETCH');
export const [PRODUCT_CATEGORIES_FETCH_STARTED, PRODUCT_CATEGORIES_FETCH_SUCCEEDED, PRODUCT_CATEGORIES_FETCH_FAILED] =
    createAsyncActionTypes(PRODUCT_CATEGORIES_FETCH);

export interface ProductCategory {
    id: string;
    serviceId: string;
    names: LocalizedPropertyObject;
    shortNames: LocalizedPropertyObject;
    descriptions: LocalizedPropertyObject;
    ordering: number;
    parentCategoryId?: string | null;
}

export const [getProductCategories, getProductCategoriesByIds, getProductCategoriesByOwnerId, getProductCategory] =
    createScopedBaseEntitySelectors<ApplicationState, ProductCategory, typeof NAME, 'serviceId'>(
        parentSelector,
        NAME,
        'serviceId'
    );

export const setProductCategories = (entities: Array<ProductCategory>, scope: string) =>
    createAction(PRODUCT_CATEGORIES_FETCH_SUCCEEDED, { entities }, { scope });

export const productCategoriesReducer = createScopedEntitiesReducer({
    FETCH_SUCCESS: PRODUCT_CATEGORIES_FETCH_SUCCEEDED,
});
